module.exports = __webpack_public_path__ + "static/media/IMG_20180623_095729.f5e050c8.jpg";